import { queryInfoFromDp } from '@/business';
import { DP_PAGE } from '@/config';
import { ContentBaseData, formatContentBaseToMultiJump } from '@tencent/wphk-components-multi-jump-container/src/business';
import { DP_POSITION } from './config';
import { ReportAction, submitCheckValue } from '@tencent/wphk-components-dp-loader';
import { to } from '@tencent/wphk-base-utils';

export async function getAdData() {
  const adList = await queryInfoFromDp(DP_PAGE, [DP_POSITION]);
  if (adList.length === 0 || !adList[0]) {
    return {
      isShowAdDialog: false,
    };
  }
  return {
    isShowAdDialog: true,
    adInfo: formatContentBaseToMultiJump(adList[0].contentBaseData as ContentBaseData),
    dpId: adList[0].dpId,
  };
}

export async function browReport(dpId: number) {
  await to(
    submitCheckValue([
      {
        dpPosition: DP_POSITION,
        action: ReportAction.Close,
        dpId,
      },
    ]),
  );
}
